<template>
	<div class="gift-body">
		<div style="width:100%;flex:1;display:flex;flex-direction: column;overflow-y:auto">
			<div class="order-menu">
				<span>
					<i class="el-icon-back" @click="goBack"></i>
				</span>活动详情
			</div>
			<div class="fx-title">
				<span>基础信息</span>
				<span style="margin-left: 20px;color: #666666;font-size: 13px;" v-if="marketId !==''">修改时间：{{modifyDate}}</span>
			</div>
			<div class="gift-row">
				<div class="gift-row-title">
					<span style="color:#EE4F31">*</span>
					活动名称：
				</div>
				<div class="gift-row-content">
					<el-input v-model="name" maxlength="30" :disabled="isDisable" size="mini" placeholder="不超过30字"></el-input>
				</div>
			</div>
			<div class="gift-row">
				<div class="gift-row-title">
					活动编号：
				</div>
				<div class="gift-row-content">
					{{code}}
				</div>
			</div>
			<div class="gift-row">
				<div class="gift-row-title">
					<span style="color:#EE4F31">*</span>
					活动时间：
				</div>
				<div class="gift-row-content">
					<el-radio :disabled="isDisable" v-model="discountDateType" :label="1">自定义</el-radio>
					<el-radio :disabled="isDisable" v-model="discountDateType" :label="0">不限</el-radio>
				</div>
				<div v-if="discountDateType === 1" class="gift-row">
					<div>
						<el-date-picker
							:disabled="isDisable"
							v-model="dateValue"
							:clearable="false"
							:unlink-panels='true'
							class="time-input"
							size="mini"
							type="datetimerange"
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							:default-time="['00:00:00', '23:59:59']"
							format='yyyy-MM-dd HH:mm:ss'
							value-format='yyyy-MM-dd HH:mm:ss'>
						</el-date-picker>
					</div>
				</div>
			</div>
			<div class="gift-row">
				<div class="gift-row-title">
					<span style="color:#EE4F31">*</span>
					活动对象：
				</div>
				<div class="gift-row-content" style="width:400px">
					<el-radio :disabled="isDisable" v-model="attendway" :label="0">全部客户</el-radio>
					<el-radio :disabled="isDisable" v-model="attendway" :label="1">自定义客户</el-radio>
					<span v-if="attendway === 1 && !isDisable" @click="addCusClick" style="margin-left:10px;color:var(--fx-primary-color);cursor: pointer;font-size: 12px;">
						<i style="font-size: 14px;" class="el-icon-circle-plus"></i>
						选择客户
					</span>
				</div>
			</div>
			<div v-if="attendway === 1" class="customer-box">
				<span style="font-size: 13px;">已选：</span>
				{{cusText}}
			</div>
			<div class="gift-row">
				<div class="gift-row-title">
					<span style="color:#EE4F31">*</span>
					活动状态：
				</div>
				<div class="gift-row-content">
					<el-switch size='mini' :disabled="isDisable" v-model="disabledflag" active-color="#E9EAEB" inactive-color="var(--fx-primary-color)">
					</el-switch>
					<span style="margin-left:10px">{{disabledflag ? '停用' : '启用'}}</span>
				</div>
			</div>
			<div v-if="shopList.length > 1">
				<div class="fx-title">
					<span>适用门店</span>
				</div>
				<div style="display: flex;align-items: center;height: 40px;">
					<div style="width:90px;text-align: right;">
						适用门店：
					</div>
					<el-radio style="min-height: 40px;;line-height: 40px;" v-model="shopattendway" :label="0">全部门店</el-radio>
					<el-radio style="min-height: 40px;;line-height: 40px;" v-model="shopattendway" :label="1">自定义门店</el-radio>
					<div  v-if="shopattendway === 1" @click="bindShopClick" style="height: 20px;line-height: 20px;margin-left:10px;color:var(--fx-primary-color);cursor: pointer;font-size: 12px;">
						<i style="font-size: 14px;" class="el-icon-circle-plus"></i>
						选择门店
					</div>
				</div>
				<div v-if="shopattendway === 1" style="display: flex;align-items: center;min-height: 40px;">
					<div style="width:90px;text-align: right;">
						已选：
					</div>
					<div>{{shopText}}</div>
				</div>
			</div>
			<div class="fx-title">
				<span>活动规则</span>
			</div>
			<div style="color: #E34B4A;font-size: 12px;text-align: left;margin-bottom: 20px;margin-left: 15px;">
				<span v-if="!isMuti">商品买赠：1、活动规则对于每个主商品单独生效，满足赠送条件单独赠送；2、有辅助单位时按辅助单位计算；3、多规格商品任意规格相加满足赠送条件即可</span>
				<span v-if="isMuti">组合买赠：1、活动针对选择的多个商品生效，所选商品任意组合满足条件即可赠送。2、有辅助单位时按辅助单位计算</span>
			</div>
			<div class="row-box">
				<span style="color: #E34B4A;">*</span> 主商品
				<span style="font-size: 12px;color: #999999;">（最多支持1000个）</span>
			</div>
			<div class="row-box">
				<el-button style="width: 120px;" @click="addProduct" size="mini" plain type="primary" icon='el-icon-plus'> 添加主商品</el-button>
			</div>
			<div class="main-product-box">
				<div style="height: 200px;">
					<el-table
						:stripe='true'
						size='mini'
						class="grid-content"
						:data="product2"
						height="100%"
						border>
						<el-table-column
							prop="typeCategory"
							label="商品类别"
							align="center"
							min-width="120">
						</el-table-column>
						<el-table-column
							prop="productname"
							label="商品名称"
							align="center"
							min-width="120">
						</el-table-column>
						<el-table-column
							prop="productcode"
							label="SPU编号"
							align="center"
							min-width="100">
						</el-table-column>
						<el-table-column
							key="disabledflag"
							prop="disabledflag"
							label="启用状态"
							align="center">
							<template slot-scope='scope'>
								<div class="point-box">
									<div v-if="!scope.row.disabledflag" class='point' style="background-color:#60C769"></div>
									<div v-if="scope.row.disabledflag" class='point' style="background-color:#ED4F31"></div>
									<span>{{scope.row.disabledflag ? '已停用' : '已启用'}}</span>
								</div>
							</template>
						</el-table-column>
						<el-table-column v-if="!isDisable" label="操作" min-width="100" align="center">
							<template slot-scope="scope">
								<el-button type='text' size="mini" @click='delProduct(scope.row.productid)'>删除</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
			<div class="rule-row-box">
				<span style="color:#E34B4A;">*</span>
				赠送方式：
				<el-radio :disabled="isDisable" @change="ruleChange" v-model="discountrule" :label="0">仅赠送1次</el-radio>
				<el-radio :disabled="isDisable" @change="ruleChange" v-model="discountrule" :label="1">每满足则赠送</el-radio>
				<el-radio :disabled="isDisable" @change="ruleChange" v-model="discountrule" :label="2">阶梯赠送</el-radio>
			</div>
			<div class="rule-row-box">
				<span style="color:#E34B4A">*</span>
				赠送条件：
				<el-radio :disabled="isDisable" v-model="producttype" :label="0">购买主商品达到规定数量</el-radio>
				<el-radio :disabled="isDisable" v-model="producttype" :label="1">购买主商品达到规定金额</el-radio>
			</div>
			<div class="gift-box" v-for="(item, index) in giftArr" :key="index">
				<div class="gift-box-left">
					<div class="gift-box-title" v-if="discountrule === 2">
						<div class="gift-btn-box">
							<img style="width: 16px;height: 16px;" src="~/images/icon/jieti-icon.png" alt="">
							<span style="font-family: MicrosoftYaHei;color: var(--fx-primary-color);font-size: 15px;font-style: italic;margin-left: 5px;">阶梯{{index + 1}}:</span>
						</div>
						<div class="gift-btn-box">
							<i class="el-icon-circle-plus" v-if="giftArr.length < 10" type='text' size="mini" @click='addGiftRow'></i>
							<i class="el-icon-remove" style="color: #999999;margin-left: 20px;" v-if="giftArr.length > 1" @click="delGiftRow(index)"></i>
						</div>
					</div>
					<div style="margin-bottom: 10px;text-align: left;">
						<div v-show="producttype === 0">购买主商品数量满<el-input v-model="item.productcount" @change="checkCount(index)" size="mini" style="margin:0 8px;width:130px"></el-input>即赠赠品</div>
						<div v-show="producttype === 1">购买主商品金额满<el-input v-model="item.productmoney" @input="checkMoney(index)" size="mini" style="margin:0 8px;width:130px"></el-input>即赠赠品</div>
					</div>
					<div class="line-box"></div>
					<div style="hieght:40px;line-height:40px;text-align:left;padding-left:10px;font-size: 13px;">
						<span style="color:#EE4F31">*</span>
						赠品
					</div>
					<div style="hieght:40px;line-height:40px;text-align:left;padding-left:10px">
						<el-button size="mini" v-if="!isDisable" @click="addGiftClick(index)" plain type="primary" icon='el-icon-plus'> 添加赠品</el-button>
					</div>
					<div style="height:200px;margin-top:10px">
						<el-table
						:stripe='true'
						size='mini'
						class="grid-content"
						:data="item.giftProductList"
						height="100%"
						border>
							<el-table-column
								prop="productname"
								label="赠品名称"
								align="center"
								min-width="120">
							</el-table-column>
							<el-table-column
								prop="productcode"
								label="SPU编号"
								align="center"
								min-width="100">
							</el-table-column>
							<el-table-column
								prop="spec"
								label="SKU名称"
								align="center"
								min-width="100">
							</el-table-column>
							<el-table-column
								prop="code"
								label="SKU编号"
								align="center"
								min-width="100">
							</el-table-column>
							<el-table-column
								prop="visibleflag"
								label="可见状态"
								align="center"
								min-width="160">
								<template template slot="header">
									<div>可见状态
										<el-tooltip class="item" effect="dark" content="*可见状态是控制该商品在可以销售的情况下，买家在小程序中无法主动进行检索、下单等，但是可以通过作为附属品，赠品提单" placement="top">
											<i class="el-icon-warning-outline" style="color: var(--fx-primary-color);"></i>
										</el-tooltip>
									</div>
								</template>
								<template slot-scope='scope'>
									{{scope.row.visibleflag ? '可见':'不可见'}}
								</template>
							</el-table-column>
							<el-table-column
								prop="price"
								label="单价"
								align="center"
								min-width="80">
								<template>
									<span>0.00</span>
								</template>
							</el-table-column>
							<el-table-column
								prop="discountstate"
								label="数量"
								align="center"
								min-width="160">
								<template slot-scope='scope'>
									<el-input :disabled="isDisable" style="width: 80%;" @input='checkNum(scope.row)' @blur="blurNum(scope.row)" v-model="scope.row.productcount" size="mini"></el-input>
								</template>
							</el-table-column>
							<el-table-column v-if="!isDisable" label="操作" min-width="100" align="center">
								<template slot-scope="scope">
									<el-button type='text' size="mini" @click='delClick(index, scope.row.productid)'>删除</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
			</div>
		</div>
		<div style="height:60px;line-height:60px;width:100%;text-align:center">
			<el-button size="mini" v-if="!isDisable" type="primary" @click='saveClick(false)'>保存</el-button>
			<el-button size="mini" v-if="marketId ==='' && !isDisable" type="primary" @click='saveClick(true)'>保存并创建新活动</el-button>
		</div>
		<el-dialog
			:title="isGift === 1 ? '选择赠品' : '选择主商品'"
			:visible.sync="productModel"
			class="dialog-title"
			width="1260px"
			top="60px"
			@open="search"
			:close-on-click-modal="false">
			<div class="dialog-body">
				<div class="filters-container">
					<div class="input-box">
						<span>商品类别：</span>
						<el-select filterable v-model="typeCategory" class="filter-input" size='mini'>
							<el-option value="0" label="全部"></el-option>
							<el-option :value="item.id" :label="item.name" v-for="item in categoryList" :key="item.id"></el-option>
						</el-select>
					</div>
					<div class="input-box">
						<span>启用状态：</span>
						<el-select v-model="productDisabledflag" class="filter-input" size='mini'>
							<el-option :value='-1' label="全部"></el-option>
							<el-option :value='0' label="启用"></el-option>
							<el-option :value='1' label="停用"></el-option>
						</el-select>
					</div>
					<div class="input-box">
						<el-input
							v-model="productKeyword"
							placeholder="商品名称/编号"
							size="mini"
							@keyup.enter.native="search">
						</el-input>
					</div>
					<el-button size="small" type="primary" class="btn fx-btn" @click="searchClick">查询</el-button>
					<el-button size="small" plain class="btn fx-btn" @click="clearSearch">清空</el-button>
				</div>
				<div v-if="isGift === 1" class="filters-container">
					<div class="input-box">
						<span>可见状态：</span>
						<el-select v-model="visibleflag" class="filter-input" size='mini'>
							<el-option :value='-1' label="全部"></el-option>
							<el-option :value='true' label="可见"></el-option>
							<el-option :value='false' label="不可见"></el-option>
						</el-select>
					</div>
				</div>
				<el-table
					class="grid-content"
					:data="productTableData"
					border
					size='mini'
					height="400"
					ref="table"
					@select="handleSelectionChange"
					@select-all="handleSelectionChange"
				>
					<el-table-column
						key='checkbox'
						type="selection"
						align="center"
						width="40">
					</el-table-column>
					<el-table-column
						key='typeCategory'
						prop="typeCategory"
						label="商品类别"
						align="center">
					</el-table-column>
					<el-table-column
						key="productname"
						prop="productname"
						label="商品名称"
						align="center">
					</el-table-column>
					<el-table-column
						v-if="isGift === 1"
						key="spec"
						prop="spec"
						label="规格名称"
						align="center">
					</el-table-column>
					<el-table-column
						key="productcode"
						prop="productcode"
						label="SPU编号"
						align="center">
					</el-table-column>
					<el-table-column
						v-if="isGift === 1"
						key="visibleflag"
						prop="visibleflag"
						label="可见状态"
						align="center">
						<template template slot="header">
							<div>可见状态
								<el-tooltip class="item" effect="dark" content="*可见状态是控制该商品在可以销售的情况下，买家在小程序中无法主动进行检索、下单等，但是可以通过作为附属品，赠品提单" placement="top">
									<i class="el-icon-warning-outline" style="color: var(--fx-primary-color);"></i>
								</el-tooltip>
							</div>
						</template>
						<template slot-scope='scope'>
							<div class="point-box">
								<span>{{scope.row.visibleflag ? '可见' : '不可见'}}</span>
							</div>
						</template>
					</el-table-column>
					<el-table-column
						key="disabledflag"
						prop="disabledflag"
						label="启用状态"
						align="center">
						<template slot-scope='scope'>
							<div class="point-box">
								<div v-if="!scope.row.disabledflag" class='point' style="background-color:#60C769"></div>
								<div v-if="scope.row.disabledflag" class='point' style="background-color:#ED4F31"></div>
								<span>{{scope.row.disabledflag ? '已停用' : '已启用'}}</span>
							</div>
						</template>
					</el-table-column>
				</el-table>
				<div style="display: flex;align-items: center;justify-content: space-between;height: 40px;">
					<div>
						<span v-if="isGift === 1">
							已选：{{this.chooseData.length}}
						</span>
					</div>
					<el-pagination
						style="margin: 10px; text-align: center;"
						@size-change="productSizeChange"
						@current-change="productPageChange"
						:current-page="productPagination.page"
						:page-sizes="[20, 40, 60, 100, 300]"
						:page-size="productPagination.size"
						layout="total, sizes, prev, pager, next, jumper"
						:total="productTotalCount">
					</el-pagination>
				</div>

				<div class="valet-foot">
					<el-button plain type="primary" size='small' @click='cancelClick'>取消</el-button>
					<el-button v-if="isGift === 0" plain type="primary" size='small' @click='addproductClick'>添加</el-button>
					<el-button v-if="isGift === 1" plain type="primary" size='small' @click='addgiftClick'>添加</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog
			title="选择活动对象"
			:visible.sync="customerDialog"
			class="dialog-title"
			width="780px"
			top="60px"
			@open="search"
			:close-on-click-modal="false">
			<div class="dialog-body">
				<bind-customer v-if="customerDialog" :customerDialog.sync="customerDialog" @reloadCus='reloadCus' :customertype='customertype' :chooseCusByCate='chooseCusByCate' :chooseCusBylevel='chooseCusBylevel'></bind-customer>
			</div>
		</el-dialog>
		<el-dialog
			title="提示"
			class="dialog-title"
			:visible.sync="showError"
			width="30%">
			<div style="width: 100%;max-height: 300px;overflow-y:auto ;">
				<div style="padding: 5px 10px;text-align: left;" v-for="(item,index) in errorList" :key='index'>
					【{{item.customername}}】在【{{item.name}}】的买赠活动中已绑定关系！
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" size="mini" @click="showError = false">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog
			top='100px'
			title="选择适用门店"
			class="dialog-title"
			:visible.sync="shopDialog"
			width="780px"
			append-to-body
			:close-on-click-modal="false">
			<div>
				<bindShop v-if="shopDialog" :customerDialog.sync='shopDialog' :chooseData1='chooseShop' @reloadCus='reloadShop'></bindShop>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import BindCustomer from './bindCustomer.vue'
import bindShop from '@/components/bindShop/bindShop.vue'
export default {
	name: 'gift',
	components: {
		BindCustomer,
		bindShop
	},
	data () {
		return {
			visibleflag: -1,
			modifyDate: '',
			AuthorityList: {
				'08_0002_0001_00': false,
				'08_0002_0002_00': false,
				'08_0002_0003_00': false,
				'08_0002_0004_00': false,
				'08_0008_0001_00': false,
				'08_0008_0002_00': false,
				'08_0008_0003_00': false,
				'08_0008_0004_00': false
			},
			showError: false,
			errorList: [],
			cusText: '',
			productPagination: {
				page: 1,
				size: 20
			},
			productTotalCount: 0,
			categoryList: [],
			productKeyword: '',
			productDisabledflag: -1,
			typeCategory: '0',
			disabledflag: false,
			product: [],
			product2: [],
			name: '',
			type: 0,
			code: '',
			attendway: 0,
			discountDateType: 0,
			dateValue: [],
			productModel: false,
			productTableData: [],
			// chooseData: [],
			chooseId: '',
			planDisabledflag: -1,
			// chooseGift: [],
			isGift: null,
			marketId: '',
			oldCus: '',
			customerDialog: false,
			chooseCusByCate: [],
			chooseCusBylevel: [],
			chooseCus: [],
			customertype: 0,
			decimal: 0,
			isDisable: true,
			tableSelectUtils: this.$fxUtils.tableSelectUtils({
				key: 'keyid'
			}),
			producttype: 0,
			productcount: 1,
			productmoney: '',
			reachNum: 1,
			shopattendway: 0,
			shopDialog: false,
			shopText: '',
			chooseShop: [],
			shopList: [],
			discountrule: 0,
			// 添加多种商品
			productIds: [],
			giftArr: [{
				giftProductList: [],
				productmoney: '',
				productcount: ''
			}],
			giftIndex: null,
			giftList1: [{
				giftProductList: [],
				productmoney: '',
				productcount: ''
			}],
			giftList2: [{
				giftProductList: [],
				productmoney: '',
				productcount: ''
			}],
			oldDiscountrule: 0,
			isMuti: false
		}
	},
	created () {
		this.isMuti = window.location.hash.split('/')[window.location.hash.split('/').length - 1] === 'mutigift'
		let menuNo = this.isMuti ? '9-8' : '9-2'
		this.$fxEventBus.$emit('setMenu', menuNo)
		this.getAuthority()
		this.getOrderSystemSetting()
		this.getCategoryList()
		let id = window.sessionStorage.getItem('marketid')
		if (id) {
			this.marketId = id
			this.getDetail()
		}
		this.getShop()
	},
	computed: {
		chooseData () {
			return this.tableSelectUtils.getSelectRows()
		}
	},
	methods: {
		checkGift () {
			let list = this.giftArr
			let flag = true
			for (let i = 0; i < list.length; i++) {
				if (!flag) {
					return false
				}
				if (list[i].giftProductList.length === 0) {
					flag = false
					this.$message.error('至少选择一个赠品')
					return false
				}
				if (list[i].giftProductList.length > 20) {
					flag = false
					this.$message.error('最多支持添加20个赠品')
					return false
				}
				if (this.producttype === 0 && list[i].productcount === '') {
					flag = false
					this.$message.error('购买主商品数量不能为空')
					return false
				}
				if (this.producttype === 1 && list[i].productmoney === '') {
					flag = false
					this.$message.error('购买主商品金额不能为空')
					return false
				}
				if (i > 0) {
					if (this.producttype === 0 && (+list[i].productcount === +list[i - 1].productcount)) {
						flag = false
						this.$message.error('阶梯区间不可重复')
						return false
					}
					if (this.producttype === 1 && (+list[i].productmoney === +list[i - 1].productmoney)) {
						flag = false
						this.$message.error('阶梯区间不可重复')
						return false
					}
					if (this.producttype === 0 && (+list[i].productcount < +list[i - 1].productcount)) {
						flag = false
						this.$message.error('阶梯区间需从小到大设置')
						return false
					}
					if (this.producttype === 1 && (+list[i].productmoney < +list[i - 1].productmoney)) {
						flag = false
						this.$message.error('阶梯区间需从小到大设置')
						return false
					}
				}
			}
			return flag
		},
		ruleChange () {
			if (this.oldDiscountrule === 2) {
				this.giftList2 = this.giftArr
			} else {
				this.giftList1 = this.giftArr
			}
			if (this.discountrule === 2) {
				this.giftArr = this.giftList2
			} else {
				this.giftArr = this.giftList1
			}
			this.oldDiscountrule = this.discountrule
		},
		delGiftRow (index) {
			this.giftArr.splice(index, 1)
		},
		addGiftRow () {
			if (!this.checkGift()) {
				return false
			}
			let row = {
				giftProductList: [],
				productmoney: '',
				productcount: ''
			}
			this.giftArr.push(row)
		},
		getShop () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/selectShopList`
			}).then(res => {
				this.shopList = res
			}).catch(() => {
			})
		},
		handleChange (value) {
			console.log(value)
		},
		getAuthority () {
			let id = this.isMuti ? '08_0008_0000_00' : '08_0002_0000_00'
			let params = {
				pId: id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
					let id = window.sessionStorage.getItem('marketid')
					if (id) {
						this.isDisable = this.isMuti ? !this.AuthorityList['08_0008_0002_00'] : !this.AuthorityList['08_0002_0002_00']
					} else {
						this.isDisable = this.isMuti ? !this.AuthorityList['08_0008_0003_00'] : !this.AuthorityList['08_0002_0003_00']
					}
				}
			})
		},
		getOrderSystemSetting () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/getOrderSystemSetting`
			}).then(res => {
				if (res.result) {
					this.decimal = res.data.orderdecimalcount
				} else {
					this.$message.error(res.msg)
				}
			}).catch((res) => {
				this.$message.error(res.msg)
			})
		},
		blurNum (row) {
			if (row.productcount === '' || row.productcount === null || +row.productcount === 0) {
				row.productcount = 1
			}
			row.productcount = +row.productcount
			if (row.productcount > 1000000 || row.productcount === 1000000) {
				switch (this.decimal) {
				case 0:
					row.productcount = 999999
					break
				case 1:
					row.productcount = 999999.9
					break
				case 2:
					row.productcount = 999999.99
					break
				case 3:
					row.productcount = 999999.999
					break
				case 4:
					row.productcount = 999999.9999
					break
				}
			}
		},
		checkNum (row) {
			row.productcount = row.productcount.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			row.productcount = row.productcount.replace(/^\./g, '')// 验证第一个字符是数字而不是
			row.productcount = row.productcount.replace(/\.{2,}/g, '.')// 只保留第一个. 清除多余的
			row.productcount = row.productcount.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
			switch (this.decimal) {
			case 0:
				row.productcount = row.productcount.replace(/(^[0]|[^\d])/g, '')
				break
			case 1:
				row.productcount = row.productcount.replace(/^(\-)*(\d+)\.(\d).*$/, '$1$2.$3')
				break
			case 2:
				row.productcount = row.productcount.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
				break
			case 3:
				row.productcount = row.productcount.replace(/^(\-)*(\d+)\.(\d\d\d).*$/, '$1$2.$3')
				break
			case 4:
				row.productcount = row.productcount.replace(/^(\-)*(\d+)\.(\d\d\d\d).*$/, '$1$2.$3')
				break
			}
		},
		checkCount (index) {
			this.giftArr[index].productcount = this.giftArr[index].productcount + ''
			this.giftArr[index].productcount = this.giftArr[index].productcount.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			this.giftArr[index].productcount = this.giftArr[index].productcount.replace(/^\./g, '')// 验证第一个字符是数字而不是
			this.giftArr[index].productcount = this.giftArr[index].productcount.replace(/\.{2,}/g, '.')// 只保留第一个. 清除多余的
			this.giftArr[index].productcount = this.giftArr[index].productcount.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
			this.giftArr[index].productcount = this.giftArr[index].productcount.replace(/(^[0]|[^\d])/g, '')
			if (+this.giftArr[index].productcount > 99999999) {
				this.giftArr[index].productcount = 99999999
			}
		},
		checkMoney (index) {
			this.giftArr[index].productmoney = this.giftArr[index].productmoney.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			this.giftArr[index].productmoney = this.giftArr[index].productmoney.replace(/^\./g, '')// 验证第一个字符是数字而不是
			this.giftArr[index].productmoney = this.giftArr[index].productmoney.replace(/\.{2,}/g, '.')// 只保留第一个. 清除多余的
			this.giftArr[index].productmoney = this.giftArr[index].productmoney.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
			this.giftArr[index].productmoney = this.giftArr[index].productmoney.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
			if (+this.giftArr[index].productmoney > 99999999) {
				this.giftArr[index].productmoney = 99999999
			}
		},
		clearData () {
			this.name = ''
			this.type = 0
			this.code = ''
			this.attendway = 0
			this.discountDateType = 0
			this.dateValue = []
			this.giftArr = [{
				giftProductList: [],
				productmoney: '',
				productcount: ''
			}]
			this.product2 = []
			this.disabledflag = false
			this.oldCus = ''
			this.chooseCusByCate = []
			this.chooseCusBylevel = []
			this.chooseCus = []
			this.customertype = 0
		},
		reloadCus (data) {
			this.chooseCus = data.chooseData
			this.customertype = data.customertype
			if (this.customertype === 0) {
				this.chooseCusByCate = this.chooseCus
			} else {
				this.chooseCusBylevel = this.chooseCus
			}
			this.initCusData()
			this.customerDialog = false
		},
		checkCusNum (data) {
			let num = 0
			data.forEach(item => {
				if (item.id !== '-1') {
					num++
				}
			})
			return num
		},
		initCusData () {
			let textArr = []
			let list = this.chooseCus
			list.forEach(item => {
				let itemText = ''
				if (item.categoryOrLevelFlag === 1) {
					itemText = item.name + '（整类）'
				} else {
					itemText = item.name + '（' + this.checkCusNum(item.cus) + '个）'
				}
				textArr.push(itemText)
			})
			this.cusText = textArr.join('，')
		},
		initShopData (data) {
			let textArr = []
			let ids = []
			data.forEach(item => {
				ids.push(item.shopid)
				textArr.push(item.shopname)
			})
			this.shopText = textArr.join('，')
			this.chooseShop = ids
		},
		checkSave () {
			if (this.name === '') {
				this.$message.error('请填写活动名称')
				return false
			}
			if (this.discountDateType === 1 && (this.dateValue === null || this.dateValue.length === 0)) {
				this.$message.error('请选择活动时间')
				return false
			}
			if (this.product2.length === 0) {
				this.$message.error('请选择主商品')
				return false
			} else if (this.product2.length > 1000) {
				this.$message.error('所选商品数量不能大于1000')
				return false
			}
			if (this.shopattendway === 1 && this.chooseShop.length === 0) {
				this.$message.error('请选择适用门店')
				return false
			}
			if (this.attendway === 1 && this.chooseCus.length === 0) {
				this.$message.error('至少选择一个客户')
				return false
			}
			if (!this.checkGift()) {
				return false
			}
			return true
		},
		saveClick (flag) {
			if (!this.checkSave()) {
				return false
			}
			this.productIds = []
			let productData = this.product2
			productData.forEach(item => {
				this.productIds.push(item.productid)
			})
			let newCus = this.chooseCus
			let params = {
				id: this.marketId,
				name: this.name,
				attendway: this.attendway,
				discountDateType: this.discountDateType,
				beginDate: this.dateValue[0],
				endDate: this.dateValue[1],
				disabledflag: this.disabledflag,
				productids: this.productIds,
				detail: this.giftArr,
				customertype: this.customertype,
				shopIds: this.chooseShop,
				shopattendway: this.shopattendway,
				producttype: this.producttype,
				discountrule: this.discountrule
			}
			if (this.isMuti) {
				params.type = 5
			}
			if (this.oldCus !== JSON.stringify(newCus)) {
				params.customerDetail = this.chooseCus
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/shop/discount/saveorupdate4gift`,
				data: params
			}).then(res => {
				if (res.result) {
					if (flag) { // 保存并新增
						this.marketId = ''
						window.sessionStorage.removeItem('marketid')
						this.clearData()
						this.$message.success('保存成功!')
						return false
					}
					this.marketId = res.data
					window.sessionStorage.setItem('marketid', res.data)
					this.getDetail()
					this.getAuthority()
					this.$message.success('保存成功!')
				} else {
					if (res.code === 1) {
						this.errorList = []
						this.errorList = res.data
						this.showError = true
						return false
					}
					this.$message.error(res.msg)
				}
			})
		},
		addCusClick () {
			this.customerDialog = true
		},
		getDetail () {
			let params = {
				id: this.marketId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/shop/discount/getdetail4gift`,
				data: params
			}).then(res => {
				if (res.result) {
					let data = res.data
					data.mainProductList.forEach(item => {
						item.productid = item.mainProductId
						item.productcode = item.mainProductCode
						item.productname = item.mainProductName
					})
					this.product2 = data.mainProductList
					this.discountDateType = data.discount.discountDateType
					this.shopattendway = data.discount.shopattendway
					this.discountrule = data.discountrule
					this.oldDiscountrule = data.discountrule
					this.giftArr = data.gift
					if (data.discountrule === 2) {
						this.giftList2 = data.gift
					} else {
						this.giftList1 = data.gift
					}
					if (this.discountDateType === 1) {
						this.dateValue = [data.discount.begindate, data.discount.enddate]
					}
					this.customertype = data.customertype
					let cusList = data.customerList
					cusList.forEach(item => {
						item.name = this.customertype === 0 ? item.categoryname : item.levelname
						item.id = this.customertype === 0 ? item.categoryid : item.levelid
						item.showCus = 1
					})
					cusList = JSON.parse(JSON.stringify(cusList))
					this.chooseCus = cusList
					this.oldCus = JSON.stringify(cusList)
					if (this.customertype === 0) {
						this.chooseCusBylevel = []
						this.chooseCusByCate = cusList
					} else {
						this.chooseCusBylevel = cusList
						this.chooseCusByCate = []
					}
					this.modifyDate = data.discount.modifyDate
					this.name = data.discount.name
					this.attendway = data.discount.attendway
					this.disabledflag = data.discount.disabledflag
					this.code = data.discount.code
					this.marketId = data.discount.id
					this.producttype = data.producttype
					this.productcount = data.productcount
					this.productmoney = data.productmoney
					this.initCusData()
					this.initShopData(data.shops)
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		delClick (i, id) {
			let index = null
			this.giftArr[i].giftProductList.forEach((item, i) => {
				if (item.productid === id) {
					index = i
				}
			})
			this.giftArr[i].giftProductList.splice(index, 1)
		},
		cancelClick () {
			this.productModel = false
		},
		handleSelectionChange (data) {
			this.tableSelectUtils.selectToggle(this.productTableData, data)
		},
		addgiftClick () {
			if (this.chooseData.length === 0) {
				this.$message.error('最少选择一个商品')
				return false
			}
			this.giftArr[this.giftIndex].giftProductList = this.giftArr[this.giftIndex].giftProductList.concat(this.chooseData)
			this.productModel = false
		},
		delProduct (val) {
			this.product2 = this.product2.filter(item => {
				return item.productid !== val
			})
		},
		addproductClick () {
			console.log(this.chooseData)
			this.product2 = [...this.product2, ...this.chooseData]
			this.productModel = false
		},
		radioChange (data) {
			this.chooseData = this.chooseData.push(data)
			this.chooseId = data.productid
		},
		getCategoryList () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/shop/baseCategory/getShopCategories4Gift`
			}).then(res => {
				this.categoryList = res.data
			})
		},
		clearSearch () {
			this.productPagination = {
				page: 1,
				size: 20
			}
			this.typeCategory = '0'
			this.productDisabledflag = -1
			this.productKeyword = ''
			this.visibleflag = -1
			this.tableSelectUtils.clear()
			this.search()
		},
		searchClick () {
			this.tableSelectUtils.clear()
			this.search()
		},
		productSizeChange (val) {
			this.productPagination.size = val
			this.search()
		},
		productPageChange (val) {
			this.productPagination.page = val
			this.search()
		},
		search () {
			let params = {
				typeCategory: this.typeCategory,
				disabledflag: this.productDisabledflag,
				keyword: this.productKeyword,
				page: this.productPagination.page,
				size: this.productPagination.size,
				productIds: []
			}
			if (this.product2.length !== 0) {
				this.product2.forEach(item => {
					params.productIds.push(item.productid)
				})
			}
			let url = ''
			if (this.isGift) {
				url = `${this.$fxBaseApi.urlIV}/shop/discount/giftproductattrplanlist`
				params.planDisabledflag = this.planDisabledflag
				if (this.visibleflag !== -1) {
					params.visibleFlag = this.visibleflag
				}
				let list = this.giftArr[this.giftIndex].giftProductList
				if (list.length !== 0) {
					params.attrplanIds = list.map(item => {
						return item.attrplanid
					})
				}
			} else {
				url = `${this.$fxBaseApi.urlIV}/shop/discount/mainproductlist`
			}
			this.$store.dispatch('requestPost', {
				url: url,
				data: params
			}).then(res => {
				if (res.recordList === null) {
					this.productTableData = []
					this.$nextTick(() => {
						this.tableSelectUtils.setTableDefaultSelect(this.productTableData, this.$refs.table)
					})
					this.productTotalCount = res.recordCount
					return false
				}
				res.recordList.forEach(item => {
					item.keyid = this.isGift ? item.attrplanid : item.productid
				})
				this.productTableData = res.recordList
				this.$nextTick(() => {
					this.tableSelectUtils.setTableDefaultSelect(this.productTableData, this.$refs.table)
				})
				this.productTotalCount = res.recordCount
			})
		},
		goBack () {
			if (this.isMuti) {
				this.$fxEventBus.$emit('setMenu', '9-8')
				this.$router.push('mutimarketingManagement')
			} else {
				this.$fxEventBus.$emit('setMenu', '9-2')
				this.$router.push('marketingManagement')
			}
		},
		addProduct () {
			this.isGift = 0
			this.chooseData = []
			this.chooseId = ''
			this.productPagination = {
				page: 1,
				size: 20
			}
			this.productTableData = []
			this.typeCategory = '0'
			this.visibleflag = -1
			this.productDisabledflag = -1
			this.productKeyword = ''
			this.tableSelectUtils.clear()
			this.productModel = true
		},
		addGiftClick (index) {
			this.giftIndex = index
			this.isGift = 1
			this.productPagination = {
				page: 1,
				size: 20
			}
			this.chooseData = []
			this.productTableData = []
			this.typeCategory = '0'
			this.productDisabledflag = -1
			this.productKeyword = ''
			this.visibleflag = -1
			this.planDisabledflag = -1
			this.tableSelectUtils.clear()
			this.productModel = true
		},
		bindShopClick () {
			this.shopDialog = true
		},
		reloadShop (data) {
			this.chooseShop = data.chooseData
			this.shopText = data.shopText
			this.shopDialog = false
		}
	}
}
</script>
<style lang="stylus" scoped>

.gift-body{
    display: flex;
    min-width :1000px;
    width :100%;
	flex-direction: column;
    height :100%;
    overflow :hidden;
    padding-bottom :50px;
    border-radius :0px 0px 10px 10px;
	.gift-box{
		width: 100%;
		display: flex;
		flex-direction: row;
	}
	.line-box{
		height: 1px;
		background-color: #F1F1F1;
		width: 100%;
	}
	.gift-btn-box{
		height: 100%;
		display: flex;
		align-items: center;
		font-size: 30px;
		color: var(--fx-primary-color)
		i{
			cursor: pointer;
		}
	}
	.gift-box-title{
		display: flex;
		align-items: center;
		justify-content: space-between
		height: 60px
	}
	.gift-box-left{
		background-color: #F8FBFF;
		display: flex;
		flex-direction: column;
		width: 100%;
		padding: 10px;
		margin-bottom: 20px;
		box-sizing: border-box
	}
	.wid1{
		width: calc(100% - 100px)
	}
	.wid2{
		width: 100%
	}
	.row-box {
		font-size: 13px;
		color: #333333;
		text-align: left;
		margin-bottom: 20px;
	}
	.rule-row-box{
		height: 60px;
		display: flex;
		flex-shrink: 0;
		align-items: center;
		justify-content: flex-start
	}
	.order-menu {
		height: 50px
		line-height: 50px
		text-align: left
		font-size: 15px
		border-bottom: 1px solid #dce1fe
		box-sizing: border-box
		span {
			display: inline-block;
			line-height: 50px;
			padding-right: 10px;
			i {
				border-radius: 50%;
				background: #9da6af;
				padding: 3px;
				cursor: pointer;
			}
			.el-icon-back:before {
				content: "\E6EA";
				color: #fff;
				font-weight: bold;
			}
		}
	}
	.customer-box{
		line-height 40px;
		padding-left :44px;
		padding-right :20px;
		text-align :left;
		box-sizing :border-box;
	}
	.gift-row{
		min-height :40px;
		display :flex;
		flex-direction :row;
		align-items :center;
		.gift-row-title{
			width :80px;
			height :40px;
			display :flex;
			align-items :center;
			font-size :13px;
			justify-content: flex-end;
		}
		.gift-row-content{
			width :200px;
			height:40px;
			display :flex;
			align-items :center;
			text-align :left
		}
		.condition-des {
			color:#EE4F31;
			text-align:left;
			margin-bottom: 5px
		}
	}
	.main-product-box{
		text-align: left;
	}
	.product-name-box{
		display:inline-block;
		background-color:#eceffc;
		padding:0px 10px;
		line-height:30px;
		margin-left:10px;
		border-radius: 4px;
	}
	.filters-container {
		display: flex;
		flex-direction: row;
		height: 50px;
		align-items: center;
		margin-bottom:10px;
		.input-box{
			margin-right:10px
		}
		.el-input {
			width: 200px
		}
	}
	.point{
		width:6px;
		height:6px;
		border-radius:50%;
		margin-right:10px;
	}
	.point-box{
		display :flex;
		align-items:center;
		justify-content :center
	}
	.valet-foot{
		height :40px;
		display :flex;
		align-items center;
		justify-content :center
	}
}

</style>
<style lang="stylus">
.gift-body {
	.radioClass {
		.el-radio__label{
			display:none
		}
	}
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
	.el-dialog__body{
		padding:10px 20px 0px 20px
	}
	.cell{
		padding :0px !important
	}
}
</style>
